
import { defineComponent, PropType, reactive, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { requiredRule, useFormModule } from '@/modules/_shared/forms'
import { AddMemberWithoutPassword, useMemberModule } from '@/modules/members'
import { Member, AddMember } from '@/modules/members/types'
import MembersFormFieldEmail from '@/components/members/form-fields/email.vue'
import MembersFormFieldFirstname from '@/components/members/form-fields/first-name.vue'
import MembersFormFieldLastname from '@/components/members/form-fields/last-name.vue'
import MembersFormFieldJobTitle from '@/components/members/form-fields/job-title.vue'
import MembersFormFieldPassword from '@/components/members/form-fields/password.vue'
import MembersFormFieldOrganization from '@/components/members/form-fields/organization.vue'
import { AddMemberRequest } from '@/modules/members/api'
import MembersFormFieldAllowMarketing from '@/components/members/form-fields/allow-marketing-communication.vue'

export default defineComponent({
    name: 'free-subscriptions-new-member-form',
    components: {
        MembersFormFieldAllowMarketing,
        MembersFormFieldEmail,
        MembersFormFieldFirstname,
        MembersFormFieldLastname,
        MembersFormFieldJobTitle,
        MembersFormFieldPassword,
        MembersFormFieldOrganization
    },
    props: {
        modelValue: {
            type: Object as PropType<Member>,
            required: true
        }
    },
    emits: ['pickAddedMember'],
    setup (props, { emit }) {
        const withPassword = ref<boolean>(false)
        const memberModel = reactive<AddMember>({
            firstName: '',
            lastName: '',
            password: '',
            email: '',
            jobTitleId: null,
            organizationId: '',
            allowMarketingCommunication: true
        })

        const { submitForm, createOnSuccess } = useFormModule()
        const { addMemberWithoutAuthenticationProfile, addMemberWithPasswordProfile } = useMemberModule()
        const form = ref<QForm>()

        const sendRequest = async () => {
            if (withPassword.value) {
                return addMemberWithPasswordProfile(memberModel as AddMemberRequest)
            } else {
                const { password, ...memberModelNoPass } = memberModel
                return addMemberWithoutAuthenticationProfile(memberModelNoPass as AddMemberWithoutPassword)
            }
        }

        const onSubmit = async () => {
            const response = await submitForm(
                form.value,
                sendRequest,
                createOnSuccess('Member added!')
            )
            const addedMember = { ...memberModel, id: response.memberId }
            emit('pickAddedMember', addedMember)
        }

        return {
            memberModel,
            requiredRule,
            onSubmit,
            form,
            withPassword
        }
    }
})
